<template>
  <div id="parceiros">
    <h1 class="title text-uppercase font-weight-bold">Lojistas Não Ativos</h1>
    <hr class="linha-amarela" />
    <div class="limit-table">
      <table class="table">
        <thead class="letter-orange">
          <tr>
            <th>Nome Fantasia</th>
            <th>Telefone</th>
            <th>Celular</th>
            <th style="text-align: center">Reenviar E-Mail/WhatsApp</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(lojista, index) in lojistas" :key="index">
            <td>{{ lojista.nome_fantasia }}</td>
            <td>{{ formatPhone(lojista.telefone) }}</td>
            <td>{{ formatCell(lojista.celular) }}</td>
            <td class="envelopeEmail">
              <a class="mr-2" @click.prevent="enviarEmail(lojista.id)">
                <i class="fas fa-envelope envelopeIcon"></i>
              </a>
              <a class="ml-2" @click.prevent="enviarWhatsApp(lojista)">
                <i class="fab fa-whatsapp envelopeIcon"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import makeToast from '../../mixins/makeToast';

export default {
  name: 'NotActive',
  mixins: [makeToast],
  data() {
    return {
      lojistas: null,

      dados: {
        num1: null,
        num2: null,
        id: null,
      },
    };
  },
  computed: {
    ...mapState(['token', 'dadosUsuario']),
  },
  created() {
    this.getLojistas();
  },
  methods: {
    enviarEmail(id) {
      this.loading = true;
      this.$store.dispatch('startLoader');

      this.$store
        .dispatch('partner/submitEmail', id)
        .then(async () => {
          this.makeToast('Sucesso!', 'E-Mail enviado com secesso!', 'success');
        })
        .catch(() => {
          this.makeToast(
            'Oopss!',
            'Não possível buscar os Lojistas não ativos!',
            'danger'
          );
        })
        .finally(() => {
          this.loading = false;
          this.$store.dispatch('endLoader');
        });
    },
    enviarWhatsApp(data) {
      this.dados.id = data.id;
      this.loading = true;
      this.$store.dispatch('startLoader');

      this.$store
        .dispatch('partner/submitWhatsApp', this.dados)
        .then(async () => {
          this.makeToast(
            'Sucesso!',
            'WhatsApp enviado com secesso!',
            'success'
          );
        })
        .catch(() => {
          this.makeToast(
            'Oopss!',
            'Não possível buscar os Lojistas não ativos!',
            'danger'
          );
        })
        .finally(() => {
          this.loading = false;
          this.$store.dispatch('endLoader');
        });
    },
    getLojistas() {
      this.loading = true;
      this.$store.dispatch('startLoader');

      this.$store
        .dispatch('partner/notActive', this.dadosUsuario.id)
        .then(async (response) => {
          this.lojistas = response.data;
        })
        .catch(() => {
          this.makeToast(
            'Oopss!',
            'Não possível buscar os Lojistas não ativos!',
            'danger'
          );
        })
        .finally(() => {
          this.loading = false;
          this.$store.dispatch('endLoader');
        });
    },
    formatPhone(phone) {
      return phone
        .replace(/[^0-9]/g, '')
        .replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    },
    formatCell(phone) {
      return phone
        .replace(/[^0-9]/g, '')
        .replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    },
  },
};
</script>

<style lang="css" scoped>
.limit-table::-webkit-scrollbar {
  display: none;
}
.envelopeEmail {
  text-align: center;
  color: #ed670c;
}
.envelopeIcon:hover {
  -moz-transform: scale(1.1);
  -webkit-transform: scale(1.1);
  transform: scale(1.3);
  cursor: pointer;
}
</style>
